import type { FC } from 'react';
import { TableCell, TableHead, TableRow, Typography } from '@mui/material';

const MetricDescriptionTableHead = () => {
  return (
    <TableHead sx={{ position: 'relative', zIndex: 3 }}>
      <TableRow sx={{ th: { height: 64, maxHeight: 64, px: 2 } }}>
        <TableCell align="left" sx={{ '&': { width: 280, minWidth: 280, maxWidth: 280 } }}>
          <Typography variant="body2" sx={(t) => ({ fontWeight: t.typography.fontWeightMedium })}>
            Metric
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography variant="body2" sx={(t) => ({ fontWeight: t.typography.fontWeightMedium })}>
            Descriptions
          </Typography>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default MetricDescriptionTableHead;
